// removed by extract-text-webpack-plugin
module.exports = {"sel_sl":"_2C4gpW7jhmwVIrvwY9oAoQ","sel_co1":"_257Q4dTQFaoT4cIBITqd0Z","sel_co2":"d7FUwXvhPZTSHNAbIBM-T","sel_co3":"_10NhG49BXTzUYMqMjDRLw9","sel_co4":"_1Qc88GntM1QXehiadW6MZP","sel_co5":"_14MSLQbLj_Xl7kZtjLvPC3","sel_co6":"_1jpDZ-9zMzDzt2JJ7O-6D4","sel_co7":"_3kA4hY9cQ8rfDk3er8gBCM","sel_co8":"_3wDY5We37bmkugOJ2bs0sr","sel_wh":"_3jUKSKbl7guYoTORrSWF8H","sel_ip":"_1hvlABK0eVy-lQfIS_m3Gt","soo":"x5jTIzFUaBk4qzR_pO-fg"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AttentionArtworkPageFilterBar/AttentionArtworkPageFilterBar.scss
 ** module id = 949
 ** module chunks = 0
 **/